import { render, staticRenderFns } from "./NewIncomeSourceProofs.vue?vue&type=template&id=72778e6b&"
import script from "./NewIncomeSourceProofs.vue?vue&type=script&lang=js&"
export * from "./NewIncomeSourceProofs.vue?vue&type=script&lang=js&"
import style0 from "./NewIncomeSourceProofs.vue?vue&type=style&index=0&id=72778e6b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports